import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useCallback, useRef, useState } from 'react';
import cn from 'classnames';
import { useBiAction } from '../BiTracking';
import { Box } from '../Layout/Box';
import s from './FileDropzone.module.scss';
export const FileDropzone = (param)=>{
    let { accept, disabled, testId, inputTestId, onFileSelected, renderContent, className, bi, noBi: _noBi } = param;
    const fileInputRef = useRef(null);
    const [isDragging, setIsDragging] = useState(false);
    const logBiAction = useBiAction();
    const actualInputTestId = inputTestId !== null && inputTestId !== void 0 ? inputTestId : testId ? "".concat(testId, "-input") : undefined;
    const fireBi = useCallback(()=>{
        if (bi === null || bi === void 0 ? void 0 : bi.name) {
            logBiAction({
                entityType: 'file_dropzone',
                entityName: bi.name,
                actionType: 'click',
                data: _object_spread_props(_object_spread({}, bi.data), {
                    test_id: testId !== null && testId !== void 0 ? testId : ''
                })
            });
        }
    }, [
        bi,
        logBiAction,
        testId
    ]);
    const handleClick = ()=>{
        if (!disabled) {
            var _fileInputRef_current;
            (_fileInputRef_current = fileInputRef.current) === null || _fileInputRef_current === void 0 ? void 0 : _fileInputRef_current.click();
        }
    };
    const handleFileChange = (e)=>{
        var _e_target_files;
        const file = (_e_target_files = e.target.files) === null || _e_target_files === void 0 ? void 0 : _e_target_files[0];
        if (file) {
            fireBi();
            onFileSelected(file);
        }
        if (fileInputRef.current) {
            fileInputRef.current.value = '';
        }
    };
    const handleDrop = (e)=>{
        var _e_dataTransfer_files;
        e.preventDefault();
        setIsDragging(false);
        const file = (_e_dataTransfer_files = e.dataTransfer.files) === null || _e_dataTransfer_files === void 0 ? void 0 : _e_dataTransfer_files[0];
        if (file) {
            fireBi();
            onFileSelected(file);
        }
    };
    const handleDragOver = (e)=>{
        e.preventDefault();
        setIsDragging(true);
    };
    const handleDragLeave = ()=>{
        setIsDragging(false);
    };
    return /*#__PURE__*/ _jsxs(Box, {
        testId: testId,
        className: cn(s.dropzone, className, {
            [s.disabled]: disabled,
            [s.dragging]: isDragging
        }),
        onClick: handleClick,
        onDrop: handleDrop,
        onDragOver: handleDragOver,
        onDragLeave: handleDragLeave,
        children: [
            /*#__PURE__*/ _jsx("input", {
                ref: fileInputRef,
                type: "file",
                accept: accept,
                className: s.hiddenInput,
                onChange: handleFileChange,
                "data-testid": actualInputTestId
            }),
            renderContent({
                isDragging
            })
        ]
    });
};
